import React from 'react';
import styled from 'styled-components';
// import SubTitle from '../components/SubTitle'; // 현재 사용 안 함
import SideBar from './SideBar';
import SubTel from '../components/SubTel';
import Location from '../components/Location';

/**
 * 재사용 가능한 서브페이지 템플릿 컴포넌트
 * 모든 서브페이지(센터소개, 사업안내, 커뮤니티 등)에서 공통으로 사용하는 레이아웃
 *
 * @param {Object} props
 * @param {string} props.title - 페이지 제목
 * @param {string} props.description - 페이지 설명
 * @param {Array} props.menuItems - 사이드바 메뉴 항목들 [{id, label, path}, ...]
 * @param {string} props.currentNo - 현재 선택된 메뉴 번호
 * @param {string} props.submenuTitle - 현재 서브메뉴 제목
 * @param {string} props.breadcrumbMenu - 브레드크럼 메뉴명
 * @param {string} props.breadcrumbLink - 브레드크럼 기본 링크
 * @param {string} props.contentHeight - 콘텐츠 영역 높이
 * @param {React.ReactNode} props.children - 실제 콘텐츠
 *
 * @example
 * ```jsx
 * <SubPage
 *   title="센터소개"
 *   description="중구행복돌봄센터는..."
 *   menuItems={menuItems}
 *   currentNo={no}
 *   submenuTitle="인사말"
 *   breadcrumbMenu="센터소개"
 *   breadcrumbLink="/introduce/1"
 * >
 *   <div>실제 콘텐츠</div>
 * </SubPage>
 * ```
 */
const SubPage = ({
  title,
  description,
  menuItems,
  currentNo,
  submenu,
  submenuTitle,
  breadcrumbMenu,
  breadcrumbLink,
  contentHeight,
  telHeight = '4',
  children,
}) => {
  return (
    <Container>
      <Content>
        {/* 좌측 사이드바 */}
        <LeftContent>
          {/* 페이지 타이틀 */}
          {/* <SubTitle name={title} value={description} /> */}

          {/* 서브메뉴 */}
          {menuItems && menuItems.length > 0 && (
            <SideBar menuItems={menuItems} currentNo={currentNo} />
          )}

          {/* 전화번호 박스 */}
          <SubTel height={telHeight} />
        </LeftContent>

        {/* 우측 콘텐츠 영역 */}
        <RightContent $height={contentHeight}>
          {/* 브레드크럼 네비게이션 */}
          <Location
            menu={breadcrumbMenu}
            submenu={submenu ?? submenuTitle}
            link={breadcrumbLink}
          />

          {/* 서브메뉴 제목 */}
          <ContentTitle>{submenuTitle}</ContentTitle>

          {/* 실제 콘텐츠 */}
          <ContentContainer>{children}</ContentContainer>
        </RightContent>
      </Content>
    </Container>
  );
};

export default SubPage;

/* Styled Components */

const Container = styled.div`
  /* 데스크톱 기본 스타일 */
  display: flex;
  justify-content: center;
  border-top: solid;
  border-color: #f4f4f4;
  border-width: 52px;
  margin-bottom: 50px;
  width: 100%;
  box-sizing: border-box;

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    border-top: none;
    margin-bottom: 0;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
`;

const Content = styled.div`
  /* 데스크톱 기본 스타일 */
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  width: 1100px;
  box-sizing: border-box;

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    width: 100%;
    max-width: 100%;
    margin-top: 0;
    flex-direction: column;
    box-sizing: border-box;
  }
`;

const LeftContent = styled.div`
  /* 데스크톱 기본 스타일 */
  flex: 1;
  box-sizing: border-box;

  /* 모바일 스타일 - SubTitle과 SideBar만 표시, SubTel 숨김 */
  @media (max-width: 767px) {
    width: 100%;
    max-width: 100%;
    order: 1; /* 먼저 표시 */
    box-sizing: border-box;
    overflow: visible; /* hidden에서 visible로 변경 */
    margin-bottom: 0;
  }
`;

const RightContent = styled.div`
  /* 데스크톱 기본 스타일 */

  display: flex;
  flex-direction: column;
  flex: 3;
  margin-left: 10px;
  box-sizing: border-box;

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    width: 100%;
    max-width: 100%;
    margin-left: 0;
    margin-top: 0; /* LeftContent 바로 아래 붙도록 */
    overflow: visible;
    order: 2; /* LeftContent 다음에 표시 */
    box-sizing: border-box;
  }
`;

const ContentTitle = styled.h2`
  /* 데스크톱 기본 스타일 */
  display: flex;
  font-size: 40px;
  font-family: 'Nanum Gothic Bold';
  color: #333333;
  padding-bottom: 20px;
  padding-top: 20px;
  border-top: 2px solid #666666;
  padding-left: 10px;
  box-sizing: border-box;
  width: 100%;
  white-space: pre-line;

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    font-size: 24px;
    padding: 15px 5%;
    border-top: 1px solid #e0e0e0;
    margin: 0;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
`;

const ContentContainer = styled.div`
  /* 데스크톱 기본 스타일 */
  padding: 0 10px;
  box-sizing: border-box;
  margin-bottom: 50px;
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    padding: 0;
    overflow: visible;
  }
`;
